import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MessageIdToRemind {
  messageId: string | null;
}

const initialState: MessageIdToRemind = {
  messageId: null,
};

export const messageToQuote = createSlice({
  name: "messageToQuote",
  initialState,
  reducers: {
    addMessageToQuote: (state, action: PayloadAction<string>) => {
      state.messageId = action.payload;
    },
    removeMessageToQuote: (state) => {
      state.messageId = null;
    },
  },
});

export const { addMessageToQuote, removeMessageToQuote } =
  messageToQuote.actions;

export default messageToQuote.reducer;
